import { VendorContractViewModel } from '@typeDefinitions/vendorTypes';
import { Show } from 'solid-js';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';

import { VendorLegacy } from './VendorLegacy';
import { VendorWithManagement } from './VendorWithManagement';

type Props = {
  vendor: VendorContractViewModel;
  index: number;
};

/**
 * Vendor component wrapper that conditionally renders based on vendorManagement feature flag.
 *
 * When vendorManagement flag is enabled:
 * - Shows VendorWithManagement component with vendor search, create functionality
 * - Includes Profile button, Clear Vendor button, and enhanced UI
 *
 * When vendorManagement flag is disabled:
 * - Shows VendorLegacy component with original functionality
 * - Basic vendor details form without search/create features
 */
export const Vendor = (props: Props) => {
  return (
    <>
      <Show
        when={
          isFeatureFlagEnabled(FeatureFlags.VendorManagement)() &&
          props.vendor.vendorContractXref
        }
      >
        <VendorWithManagement index={props.index} />
      </Show>
      <Show
        when={
          !isFeatureFlagEnabled(FeatureFlags.VendorManagement)() ||
          props.vendor.vendorContractXref == null
        }
      >
        <VendorLegacy {...props} />
      </Show>
    </>
  );
};
